module.exports = __webpack_public_path__ + "static/loader-ab23947ce7cb7182d7997fafbc7b99c7.gif";